module.exports = __webpack_public_path__ + "static/img/icon_rg-new.3a8d918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_rg-new.png
// module id = j+i8
// module chunks = 14